import { useSelector } from '@max/max-redux';
export function useAllStates() {
    const cityData = useSelector(state => state.citySelection);
    const { city } = cityData;
    const queryParam = useSelector(state => state.queryParam.queryParam);
    const _runtimeInfo = useSelector(state => state.queryParam._runtimeInfo);
    return {
        city,
        queryParam,
        _runtimeInfo
    };
}
